export default __webpack_public_path__ + "static/media/mobile-5.f20a4f78.png";